import { councilCustomerApi } from "@/lib/api"
import type { ApiResponseCustomerDTO, CustomerDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetCustomerDetail = (councilId: string, customerId: string) => {
  return useQuery({
    queryKey: ["customerDetail", councilId, customerId],
    queryFn: async () => {
      const response = await councilCustomerApi.getCouncilCustomer(councilId, customerId)
      return (response.data as ApiResponseCustomerDTO).data as CustomerDTO
    },
    enabled: !!councilId && !!customerId,
    throwOnError: (error) => {
      const axiosError = error as { response?: { status?: number } }
      return axiosError?.response?.status !== 410
    },
    retry: (_failureCount, error) => {
      const axiosError = error as { response?: { status?: number } }
      return axiosError?.response?.status !== 410
    },
  })
}

export default useGetCustomerDetail
